import React from 'react'
import RealtimeAdvertisingHero from './RealtimeAdvertisingHero'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import Challenge from './Challenge'
import OurSolution from './OurSolution'
import RealtimeAdvertisingTechSolutions from './RealtimeAdvertisingTechSolutions'

const RealtimeAdvertisingPage = () => {
  return (
    <>
      <Header bgColor="#121212"/>
      <RealtimeAdvertisingHero />
      <RealtimeAdvertisingTechSolutions />
      <Challenge />
      <OurSolution />
      <CallToAction/>
      <Footer/>
    </>
  )
}

export default RealtimeAdvertisingPage
